import React from 'react';
import { connect } from 'react-redux';
import SportsList from './SportsList';
import InPlay from '..';
import * as Maps from '../../../store/map';

function Sports(props) {
    return (
        <div className="main-container">
            <SportsList />
            <InPlay />
        </div>
    );
}

export default connect(Maps.mapLSportsStateToProps, Maps.mapLSportsDispatchToProps)(Sports);
